const colors = {
    COLOR_GREEN: '#26a69a',
    COLOR_RED: '#d84315',
    COLOR_GRAY: '#616161',
    COLOR_BLUE: '#0288d1'
}

export default {
    authTokenCookieName: 'auth_token'
}

export { colors };